import m from "../../geodata/es2015/thailandLow";
window.am4geodata_thailandLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/thailandLow.js
// module id = null
// module chunks = 